var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.grid.outer,attrs:{"tile":"","elevation":"0"}},[_c('v-row',{style:('min-height: ' +
        _vm.component.settings.boxHeight +
        'px;' +
        'margin-left: ' +
        _vm.marginLeftResponsive +
        'px;' +
        'margin-right: ' +
        _vm.marginRightResponsive +
        'px;'),attrs:{"no-gutters":"","justify":_vm.component.settings.justify,"align":_vm.component.settings.align}},[_c('v-col',{attrs:{"xs":"12","md":_vm.component.settings.cols}},[_c('v-card',{class:_vm.grid.inner,attrs:{"tile":"","elevation":"0"}},[_c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('v-checkbox',{attrs:{"dark":""},model:{value:(_vm.privacyCheckbox),callback:function ($$v) {_vm.privacyCheckbox=$$v},expression:"privacyCheckbox"}}),_c('span',{class:_vm.component.signing.floatText + ' mr-1',style:('font-family: ' +
                _vm.component.signing.font +
                ' !important;' +
                'color: ' +
                _vm.component.signing.color +
                ';' +
                'font-size: ' +
                _vm.component.signing.size +
                'px;' +
                'font-weight: ' +
                _vm.component.signing.weight +
                ';' +
                'line-height: ' +
                _vm.component.signing.lineHeight +
                ';' +
                'font-style: ' +
                _vm.component.signing.style +
                ';')},[_c('div',[_vm._v("I agree to the")])]),_c('span',{class:_vm.component.terms.floatText + ' mr-1',style:('font-family: ' +
                _vm.component.terms.font +
                ' !important;' +
                'color: ' +
                _vm.component.terms.color +
                ';' +
                'font-size: ' +
                _vm.component.terms.size +
                'px;' +
                'font-weight: ' +
                _vm.component.terms.weight +
                ';' +
                'line-height: ' +
                _vm.component.terms.lineHeight +
                ';' +
                'font-style: ' +
                _vm.component.terms.style +
                ';')},[_c('div',[_vm._v(_vm._s(_vm.component.terms.value))])]),_c('span',{class:_vm.component.signing.floatText + ' mr-1',style:('font-family: ' +
                _vm.component.signing.font +
                ' !important;' +
                'color: ' +
                _vm.component.signing.color +
                ';' +
                'font-size: ' +
                _vm.component.signing.size +
                'px;' +
                'font-weight: ' +
                _vm.component.signing.weight +
                ';' +
                'line-height: ' +
                _vm.component.signing.lineHeight +
                ';' +
                'font-style: ' +
                _vm.component.signing.style +
                ';')},[_c('div',[_vm._v("and")])]),_c('span',{class:_vm.component.signing.floatText,style:('font-family: ' +
                _vm.component.terms.font +
                ' !important;' +
                'color: ' +
                _vm.component.terms.color +
                ';' +
                'font-size: ' +
                _vm.component.terms.size +
                'px;' +
                'font-weight: ' +
                _vm.component.terms.weight +
                ';' +
                'line-height: ' +
                _vm.component.terms.lineHeight +
                ';' +
                'font-style: ' +
                _vm.component.terms.style +
                ';')},[_c('div',[_vm._v("Privacy Policy")])])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }